import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'

export const isNewAuthSystemEnabled = import.meta.env.VITE_APP_AUTH_SYSTEM === 'provider'

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_AUTH_PROVIDER_URL || ''}/auth/api/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token')

      if (token) {
        headers.set('Authorization', isNewAuthSystemEnabled ? `Bearer ${token}` : '')
      }

      return headers
    },
  }),
  endpoints: () => ({}),
})
